export const constructAbsoluteAppUrl = (path) =>
  `${process.env.RAZZLE_API_URL}${path}`
